// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import UAT from '../../jsw/uat-base';

const uat = ({ userActivityTracking: { enabled, dummyRequest, firehose, debug }, instanceId }) => {
    if (!enabled) {
        return;
    }

    UAT.init({
        instanceId,
        accountLevel: 'admin',
        accountId: '1',
        sessionId: '0000',
        firehose: dummyRequest ? null : firehose,
        // eslint-disable-next-line no-console
        logger: debug ? console.log : null,
    });
};

export default uat;



// WEBPACK FOOTER //
// ./app/repair/uat.js